import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    wrapper: "flex flex-row gap-8",
    logo: "h-4"
  },
  variants: {}
}), r = e({
  slots: {
    background: "",
    wrapper: "",
    requiredAgeWrapper: "",
    requiredAge: "",
    requiredAgeLabel: "",
    countries: "",
    menuWrapper: "",
    menuHeading: "",
    menu: "",
    contactWrapper: "",
    contactHeading: "",
    contactRichtext: "",
    partnerLogos: "",
    addressRichtext: ""
  },
  variants: {}
}), l = {
  main: r,
  partnerLogos: t
}, a = e({
  slots: {
    base: "border-b border-border-light",
    trigger: "flex items-center justify-between w-full py-4 lg:py-6 cursor-pointer group/facet-trigger text-left gap-4 px-3 text-heading-2xs lg:text-heading-sm",
    content: "pb-6 px-3 text-body-sm bg-background-surface text-balance -mt-2 lg:-mt-4",
    icon: "w-6 h-6",
    item: "border-b border-gray-200 last:border-b-0",
    header: "flex justify-between items-center text-heading-xl",
    headerWrapper: "flex items-center gap-2 pb-3",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:-rotate-180 group-data-[state=closed]:rotate-0 transition-transform transform w-auto w-3.5 h-3.5 mr-6 flex",
    iconClose: "hidden"
  },
  variants: {}
}), o = e({
  slots: {
    background: "bg-[#F5F3EC] py-0 lg:py-16",
    wrapper: "grid grid-flow-row auto-rows-max gap-y-10 gap-x-0.5 grid-cols-6 lg:grid-cols-12 lg:gap-x-1 lg:gap-y-20 items-start",
    text: "grid-span-full lg:row-start-2 lg:col-start-1 lg:self-end",
    countries: "justify-self-start lg:row-start-3 lg:col-start-4 lg:col-end-4 row-start-3 lg:self-end px-4 lg:px-0",
    menuWrapper: "",
    menuAccordion: "hidden",
    menuList: "grid col-span-full grid-cols-subgrid gap-y-10 text-body-lg px-4 lg:px-0",
    menuListMenu: "flex flex-col gap-2 text-body-sm text-less-emphasis-1 items-start col-span-3",
    menuListMenuHeading: "mb-2 uppercase [&>h3]:!font-medium [&>h3]:text-label-md [&>h3]:!tracking-wide",
    logo: "hidden",
    partnerLogos: "row-start-4 lg:row-start-3 col-start-1 lg:col-start-7 col-span-full self-center"
  },
  variants: {}
}), n = {
  main: o,
  accordion: a.clone()
};
export {
  l as footerTemplate1Blueprint,
  n as footerTemplate2Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
